export const TEST_ID = 'vectorIcon';
